import { importLibrary, setOptions } from "@googlemaps/js-api-loader";

import { getConfig } from "../config";

let optionsSet = false;
let placesPromise: ReturnType<typeof importLibrary<"places">> | null =
  null;

/** Loads the Google Maps Places library once; concurrent and repeat callers share one promise. */
export function loadGooglePlaces() {
  if (!optionsSet) {
    setOptions({ key: getConfig()?.GOOGLE_MAPS_API_KEY });
    optionsSet = true;
  }
  placesPromise ??= importLibrary("places").catch(
    (error: unknown) => {
      placesPromise = null;
      throw error;
    },
  );
  return placesPromise;
}
